// Admin Dashboard - Main Component
// Phase 10: Admin Dashboard
// © 2025 precatio, llc

import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import StatsOverview from './StatsOverview';
import UserManagement from './UserManagement';
import ConversationMonitor from './ConversationMonitor';
import './AdminDashboard.css';

const AdminDashboard = ({ onBack }) => {
  const { token } = useAuth();
  const [activeTab, setActiveTab] = useState('stats');
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await fetch('/api/admin/stats', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setStats(data);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-container">
      <header className="admin-header">
        <button onClick={onBack} className="admin-back-btn">← Back</button>
        <h1 className="admin-title">Admin Dashboard</h1>
      </header>

      <nav className="admin-tabs">
        <button 
          className={`admin-tab ${activeTab === 'stats' ? 'active' : ''}`}
          onClick={() => setActiveTab('stats')}
        >
          Statistics
        </button>
        <button 
          className={`admin-tab ${activeTab === 'users' ? 'active' : ''}`}
          onClick={() => setActiveTab('users')}
        >
          Users
        </button>
        <button 
          className={`admin-tab ${activeTab === 'conversations' ? 'active' : ''}`}
          onClick={() => setActiveTab('conversations')}
        >
          Conversations
        </button>
      </nav>

      <main className="admin-main">
        {loading ? (
          <div className="admin-loading">Loading...</div>
        ) : (
          <>
            {activeTab === 'stats' && <StatsOverview stats={stats} onRefresh={fetchStats} />}
            {activeTab === 'users' && <UserManagement token={token} />}
            {activeTab === 'conversations' && <ConversationMonitor token={token} />}
          </>
        )}
      </main>
    </div>
  );
};

export default AdminDashboard;
